import { FC, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PaymentDetailsBanner } from "../PaymentDetailsBanner";
import { Button, Icon } from "../../../components/common";
import { IntercomObserver } from "../../../components/observers";
import {
  CURRENCY_MAP,
  DEFAULT_FIAT_CURRENCY,
  INCOMING_PAYMENT_DETAILS_CONFIG,
} from "../../../constants";
import {
  prevStep,
  selectSelectedCalculatorInput,
} from "../../../store/reducers/paymentRequestLink";
import { PublicPaymentRequest } from "../../../types/PaymentRequestTypes";
import { copyTextToClipboard } from "../../../utils/actions/clipboard";
import { useLocalStorage } from "../../../utils/hooks/useLocalStorage";
import { PaymentDetailsWarning } from "../PaymentDetailsWarning";

export const TransferPaymentDetails: FC = () => {
  const actionContainerRef = useRef<HTMLDivElement | null>(null);
  const selectedCalculatorInput = useSelector(selectSelectedCalculatorInput);
  const dispatch = useDispatch();

  const { data: paymentRequest } = useLocalStorage<
    Partial<PublicPaymentRequest>
  >("publicPaymentRequest");

  const onClickBack = () => {
    dispatch(prevStep());
  };

  const onClickCopyDetails = () => {
    const currency = selectedCalculatorInput?.currency || DEFAULT_FIAT_CURRENCY;
    const currencyFeatures = CURRENCY_MAP[currency]?.features || [];

    if (!paymentRequest || currencyFeatures.length === 0) {
      return copyTextToClipboard("No payment details available");
    }

    const { bank_details } = paymentRequest;

    const details = currencyFeatures.reduce<string[]>((accum, current) => {
      const config = INCOMING_PAYMENT_DETAILS_CONFIG[current];

      return [...accum, `${config.label}: ${bank_details![current]}`];
    }, []);

    copyTextToClipboard(details.join("\n"));
  };

  return (
    <div className="flex flex-col justify-between h-screen w-screen md:items-center">
      <div className="md:w-1/2">
        <div className="flex flex-col px-4 gap-4">
          <div className="flex pt-2">
            <Button
              className="p-0"
              icon
              onClick={onClickBack}
              variant={Button.variant.TERTIARY}
              size={Button.size.SMALL}
            >
              <Icon icon="Arrow-left" size={24} className="white" />
            </Button>
          </div>

          <PaymentDetailsWarning />

          <PaymentDetailsBanner />
        </div>

        <div className="flex flex-col gap-4 p-4 bg-white w-full !z-[25]">
          <div ref={actionContainerRef}>
            <Button
              block
              onClick={onClickCopyDetails}
              variant={Button.variant.PRIMARY}
            >
              Copy details
            </Button>
          </div>

          <IntercomObserver footer={actionContainerRef} />
        </div>
      </div>
    </div>
  );
};
